module.exports = __webpack_public_path__ + "static/media/PBDQ_Style_Isometric.d47e1960.png";